import React from 'react';
import { ArticleSection } from './ArticleSection';
import { ExternalLink } from '../ExternalLink';
import { contextualLinks } from '../../data/site';
export function EuropeSection() {
  const link = contextualLinks.serviceGermany;
  return <ArticleSection id="europe" title="The European and German Context" data-id="element-74" data-mp="3f2f1j65q45v4">
      <p data-id="element-75" data-mp="3b1lior751h93">
        Many English businesses sell to, hire in or partner with organisations across Europe, and that
        shapes automation decisions. Data residency, international data transfers and the EU AI Act all
        come into play once a workflow processes information about people in the EU. A provider working
        with English clients should be able to explain how a workflow would be adapted for EU deployment:
        hosting region, model choice, logging and consent.
      </p>
      <p data-id="element-76" data-mp="2nc0spockhjqb">
        Germany deserves particular attention. As one of Europe’s largest economies, with a deep
        manufacturing and Mittelstand base, it is a frequent partner market for English firms. German
        organisations tend to place a high value on data protection, and where employee-facing systems
        could monitor performance, works councils may have co-determination rights that need to be
        respected before rollout.
      </p>
      <p data-id="element-77" data-mp="1to2lkn1rvgit">
        If your roadmap includes German operations or suppliers, reviewing{' '}
        <ExternalLink href={link.href} data-id="element-78" data-mp="1tpx8u80inkq2">{link.anchor}</ExternalLink> can help you understand local
        expectations and find partners who can support a cross-border rollout.
      </p>
    </ArticleSection>;
}